// extracted by mini-css-extract-plugin
export default {"mainButton":"CharityLink_mainButton__PvTr-"};